<!-- 組織結構管理 -->
      <div class="row" style="padding:  20px;">
        <div class="col-md-5">
          <div class="card h-100 organization-card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="mb-0">組織結構</h5>
              <div>
                <button class="btn btn-sm btn-outline-success me-2" (click)="refreshOrganizationData()">
                  <i class="fa fa-refresh"></i> 重新整理
                </button>
                <button class="btn btn-sm btn-success" (click)="createNewOrganization()" *ngIf="!organizationData">
                  <i class="fa fa-plus"></i> 建立組織
                </button>
              </div>
            </div>
            <div class="card-body p-0">
              <div *ngIf="isLoadingOrg" class="text-center p-4">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">正在加載...</span>
                </div>
                <p class="mt-2 text-muted">正在加載組織數據...</p>
              </div>

              <div *ngIf="!isLoadingOrg && !organizationData" class="text-center p-4">
                <p class="mb-0 text-muted">尚未設定組織結構，請點選「建立組織」按鈕開始設置。</p>
              </div>

              <div *ngIf="!isLoadingOrg && organizationData" class="org-tree p-2">
                <!-- 組織樹狀結構 (顯示所有層級的部門) -->
                <div class="root-node">
                  <div class="org-node org-company" (click)="selectNode(organizationData)">
                    <i class="fa fa-building me-2"></i> {{ organizationData.name }}
                    <button class="btn btn-sm btn-outline-success btn-add-child ms-2"
                      *ngIf="canAddSubDepartment(organizationData)"
                      (click)="prepareAddNode(organizationData, $event)">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>

                  <!-- 遞歸顯示所有部門 -->
                  <ng-container *ngTemplateOutlet="departmentTemplate; context: { departments: getDepartments(organizationData), level: 0 }"></ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-7">
          <div class="card h-100">
            <div class="card-header">
              <h5 class="mb-0" *ngIf="selectedNode && selectedNode.type === 'company'">{{ selectedNode.name }}</h5>
              <h5 class="mb-0" *ngIf="selectedNode && selectedNode.type === 'department'">{{ selectedNode.name }}</h5>
              <h5 class="mb-0" *ngIf="selectedNode && selectedNode.type === 'user'">員工資訊：{{ selectedNode.name }}</h5>
              <h5 class="mb-0" *ngIf="isAddingNode">新增{{ getNewNodeTypeText() }}</h5>
              <h5 class="mb-0" *ngIf="isCreatingOrganization">建立組織結構</h5>
              <h5 class="mb-0" *ngIf="!selectedNode && !isAddingNode && !isCreatingOrganization">組織詳細資訊</h5>
            </div>
            <div class="card-body">
              <!-- 新增成功訊息通知區塊 -->
              <div *ngIf="showSuccessMessage" class="alert alert-success alert-dismissible fade show" role="alert">
                <i class="fa fa-check-circle me-2"></i> {{ successMessage }}
                <button type="button" class="btn-close" (click)="showSuccessMessage = false"></button>
              </div>

              <!-- 新增錯誤訊息通知區塊 -->
              <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
                <i class="fa fa-exclamation-circle me-2"></i> {{ errorMessage }}
                <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
              </div>

              <!-- 組織建立表單 -->
              <div *ngIf="isCreatingOrganization" class="organization-form">
                <div class="mb-3">
                  <label for="orgName" class="form-label">組織名稱 <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="orgName" [(ngModel)]="newOrganization.name" required>
                </div>

                <div class="text-end mt-4">
                  <button class="btn btn-secondary me-2" (click)="cancelCreateOrganization()">取消</button>
                  <button class="btn btn-success" (click)="createOrganization()"
                    [disabled]="!newOrganization.name || isProcessing">
                    <span class="spinner-border spinner-border-sm me-2" *ngIf="isProcessing"></span>
                    建立組織
                  </button>
                </div>
              </div>

              <!-- 新增節點表單 -->
              <div *ngIf="isAddingNode" class="node-form">
                <!-- 顯示父級單位資訊 -->
                <div class="parent-info mb-3">
                  <h6 class="text-muted mb-2">母部門</h6>
                  <div class="parent-unit-display">
                    <i class="fa fa-building me-2" *ngIf="parentNode?.type === 'company'"></i>
                    <i class="fa fa-building-o me-2" *ngIf="parentNode?.type === 'department'"></i>
                    <span class="fw-bold">{{ parentNode?.name }}</span>
                    <span class="ms-2 text-muted">
                      ({{ getParentTypeText() }})
                    </span>
                  </div>
                  <small class="text-muted">
                    {{ getNewNodeDescription() }}
                  </small>
                </div>

                <hr class="my-3">

                <div class="mb-3">
                  <label for="nodeName" class="form-label">成員名稱 <span class="text-danger">*</span></label>
                  <select class="form-select" id="nodeName" [(ngModel)]="selectedUserId" (change)="onUserSelect(selectedUserId)" required>
                    <option value="" disabled selected>請選擇成員</option>
                    <option *ngFor="let user of availableUsersForAdd" [value]="user.id">
                      {{ user.username }} ({{ user.email }})
                    </option>
                  </select>
                </div>

                <div class="mb-3" *ngIf="newNode.type === 'user'">
                  <label for="nodeRole" class="form-label">職位 <span class="text-danger">*</span></label>
                  <select class="form-select" id="nodeRole" [(ngModel)]="newNode.role" required>
                    <option *ngFor="let role of roleOptions" [value]="role.value">
                      {{ role.label }}
                    </option>
                  </select>
                </div>

                <div class="text-end mt-4">
                  <button class="btn btn-secondary me-2" (click)="cancelAddNode()">取消</button>
                  <button class="btn btn-success" (click)="addNode()"
                    [disabled]="!newNode.name || isProcessing">
                    <span class="spinner-border spinner-border-sm me-2" *ngIf="isProcessing"></span>
                    新增{{ getNewNodeTypeText() }}
                  </button>
                </div>
              </div>

              <!-- 部門詳細資訊與人員列表 -->
              <div *ngIf="selectedNode && !isAddingNode && selectedNode.type === 'department'" class="department-detail">
                <div class="mb-3">
                  <label for="editNodeName" class="form-label">部門名稱</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="editNodeName" [(ngModel)]="editingNode.name" required>
                    <button class="btn btn-success" [disabled]="!isDirty()" (click)="updateNode()">
                      <i class="fa fa-save"></i> 儲存
                    </button>
                  </div>
                </div>

                <hr>

                <!-- 子部門列表 -->
                <div class="mb-3" *ngIf="getDepartments(selectedNode).length > 0">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="mb-0">子部門</h6>
                    <button class="btn btn-sm btn-success"
                      *ngIf="canAddSubDepartment(selectedNode)"
                      (click)="prepareAddNode(selectedNode, $event)">
                      <i class="fa fa-plus"></i> 新增子部門
                    </button>
                  </div>

                  <div class="sub-departments-list mt-3">
                    <div *ngFor="let subDept of getDepartments(selectedNode)" class="sub-dept-item mb-2">
                      <div class="d-flex justify-content-between align-items-center p-2 border rounded">
                        <div (click)="selectNode(subDept)" class="flex-grow-1 cursor-pointer">
                          <i class="fa fa-building-o me-1"></i> {{ subDept.name }}
                          <span class="text-muted ms-2">({{ getUsers(subDept).length }} 人)</span>
                        </div>
                        <div>
                          <button class="btn btn-sm btn-outline-secondary me-1" (click)="selectNode(subDept)">
                            <i class="fa fa-eye"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-danger" (click)="deleteNode(subDept, $event)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                </div>

                <!-- 部門成員列表 -->
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="mb-0">部門成員 ({{ getUsers(selectedNode).length }} 人)</h6>
                    <button class="btn btn-sm btn-success" (click)="prepareAddUser(selectedNode, $event)">
                      <i class="fa fa-user-plus"></i> 新增成員
                    </button>
                  </div>

                  <div class="members-list mt-3">
                    <div *ngFor="let user of getUsers(selectedNode)" class="member-item mb-2">
                      <div class="d-flex justify-content-between align-items-center p-3 border rounded"
                           [class.bg-light]="deletingNodeId === user.id">
                        <div (click)="selectNode(user)" class="flex-grow-1 cursor-pointer">
                          <div class="d-flex align-items-center">
                            <i class="fa fa-user me-2"></i>
                            <div>
                              <div class="fw-bold">{{ user.name }}</div>
                              <small class="text-muted" *ngIf="user.role">{{ user.role }}</small>
                            </div>
                          </div>
                        </div>
                        <div>
                          <button class="btn btn-sm btn-outline-secondary me-1" (click)="selectNode(user)" [disabled]="deletingNodeId === user.id">
                            <i class="fa fa-edit"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-danger" (click)="deleteNode(user, $event)" [disabled]="deletingNodeId === user.id">
                            <i class="fa fa-trash"></i>
                            <span class="spinner-border spinner-border-sm ms-1" *ngIf="deletingNodeId === user.id"></span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="getUsers(selectedNode).length === 0" class="text-center p-4 border rounded bg-light">
                      <p class="text-muted mb-2">此部門尚無成員</p>
                      <button class="btn btn-sm btn-success" (click)="prepareAddUser(selectedNode, $event)">
                        <i class="fa fa-user-plus"></i> 新增第一個成員
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 員工詳細資訊 -->
              <div *ngIf="selectedNode && !isAddingNode && selectedNode.type === 'user'" class="user-detail">
                <!-- 員工名稱顯示/編輯區塊 -->
                <div class="mb-3">
                  <!-- 顯示模式 -->
                  <div *ngIf="!isEditingUserInfo" class="d-flex justify-content-between align-items-center">
                    <div>
                      <label class="form-label mb-1">姓名</label>
                      <h4 class="mb-0 user-name">{{ selectedNode.name }}</h4>
                      <small class="text-muted" *ngIf="selectedNode.role">{{ selectedNode.role }}</small>
                    </div>
                    <button class="btn btn-outline-secondary btn-sm" (click)="startEditUserInfo()">
                      <i class="fa fa-edit me-1"></i> 編輯
                    </button>
                  </div>

                  <!-- 編輯模式 -->
                  <div *ngIf="isEditingUserInfo">
                    <div class="mb-3">
                      <label for="editUserName" class="form-label">姓名</label>
                      <input type="text" class="form-control" id="editUserName" [(ngModel)]="editingNode.name" required>
                    </div>

                    <div class="mb-3">
                      <label for="editUserRole" class="form-label">職位</label>
                      <select class="form-select" id="editUserRole" [(ngModel)]="editingNode.role">
                        <option value="">請選擇職位</option>
                        <option *ngFor="let role of roleOptions" [value]="role.value">
                          {{ role.label }}
                        </option>
                      </select>
                    </div>

                    <div class="text-end">
                      <button class="btn btn-secondary me-2" (click)="cancelEditUserInfo()">
                        <i class="fa fa-times"></i> 取消
                      </button>
                      <button class="btn btn-success" [disabled]="!isDirty()" (click)="updateNode()">
                        <i class="fa fa-save"></i> 儲存
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 公司詳細資訊 -->
              <div *ngIf="selectedNode && !isAddingNode && selectedNode.type === 'company'" class="company-detail">
                <div class="mb-3">
                  <label for="editCompanyName" class="form-label">公司名稱</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="editCompanyName" [(ngModel)]="editingNode.name" required>
                    <button class="btn btn-success" [disabled]="!isDirty()" (click)="updateNode()">
                      <i class="fa fa-save"></i> 儲存
                    </button>
                  </div>
                </div>

                <hr>

                <div class="company-summary">
                  <h6>公司概況</h6>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="info-card bg-light p-3 rounded">
                        <h3 class="text-center">{{ getDepartmentCount() }}</h3>
                        <p class="text-center mb-0">部門數量</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="info-card bg-light p-3 rounded">
                        <h3 class="text-center">{{ getTotalMemberCount() }}</h3>
                        <p class="text-center mb-0">總成員數量</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!selectedNode && !isAddingNode && !isCreatingOrganization" class="text-center p-4">
                <p class="text-muted mb-0">請從左側選擇一個組織或部門</p>
              </div>
            </div>
          </div>
        </div>
      </div>

<!-- 遞歸模板：用於顯示部門結構 -->
<ng-template #departmentTemplate let-departments="departments" let-level="level">
  <ul class="org-children" *ngIf="departments && departments.length > 0" [class]="'level-' + level">
    <li *ngFor="let dept of departments" class="org-child">
      <div class="org-node org-department"
        [class.active]="selectedNode?.id === dept.id"
        [style.padding-left.rem]="level * 0.5"
        (click)="selectNode(dept)">
        <i class="fa fa-building-o me-1"></i> {{ dept.name }}
        <span class="text-muted ms-2">({{ getUsers(dept).length }} 人)</span>

        <div class="node-actions">
          <button class="btn btn-sm btn-outline-success btn-add-child me-1"
            *ngIf="canAddSubDepartment(dept)"
            (click)="prepareAddNode(dept, $event)">
            <i class="fa fa-plus"></i>
          </button>
          <button class="btn btn-sm btn-outline-danger btn-delete"
            (click)="deleteNode(dept, $event)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>

      <!-- 遞歸顯示子部門 -->
      <ng-container *ngTemplateOutlet="departmentTemplate; context: { departments: getDepartments(dept), level: level + 1 }"></ng-container>
    </li>
  </ul>
</ng-template>

